module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    class: [
      'button flex py-2 text-white bg-theme-1 zoom-in',
      _vm.classname ],
    on: {
      "click": _vm.downloadList
    }
  }, [_c('Icon', {
    attrs: {
      "name": 'download',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")], 1), _vm._v(" "), _c('a', {
    ref: "download_emails",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac42c92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/EmailDownloadListButton.vue
// module id = 444
// module chunks = 1